import React, { useState } from 'react';

const GRAFANA_BASE_URL = process.env.REACT_APP_GRAFANA_URL || 'http://localhost:3002';
const DASHBOARD_PATH = '/d/universe-monitoring/universe-monitoring';

function Monitoring() {
  const [timeRange, setTimeRange] = useState('1h');
  const [isLoading, setIsLoading] = useState(true);

  const timeRanges = [
    { label: 'Letzte 15 Min', value: '15m' },
    { label: 'Letzte Stunde', value: '1h' },
    { label: 'Letzte 6 Std', value: '6h' },
    { label: 'Letzte 24 Std', value: '24h' },
    { label: 'Letzte 7 Tage', value: '7d' },
  ];

  const grafanaUrl = `${GRAFANA_BASE_URL}${DASHBOARD_PATH}?orgId=1&from=now-${timeRange}&to=now&refresh=10s&kiosk`;

  return (
    <div className="monitoring">
      <div className="monitoring-header">
        <h1>Monitoring</h1>
        <p className="monitoring-subtitle">Service-Monitoring & Backend-Analyse</p>
      </div>

      <div className="monitoring-controls">
        <div className="time-range-selector">
          {timeRanges.map((range) => (
            <button
              key={range.value}
              className={`time-range-btn ${timeRange === range.value ? 'active' : ''}`}
              onClick={() => setTimeRange(range.value)}
            >
              {range.label}
            </button>
          ))}
        </div>
        <a
          href={`${GRAFANA_BASE_URL}${DASHBOARD_PATH}`}
          target="_blank"
          rel="noopener noreferrer"
          className="grafana-link-btn"
        >
          In Grafana öffnen ↗
        </a>
      </div>

      <div className="monitoring-iframe-container">
        {isLoading && (
          <div className="monitoring-loading">
            <div className="loading-spinner"></div>
            <p>Lade Dashboard...</p>
          </div>
        )}
        <iframe
          src={grafanaUrl}
          title="Grafana Monitoring Dashboard"
          className="monitoring-iframe"
          onLoad={() => setIsLoading(false)}
          frameBorder="0"
        />
      </div>
    </div>
  );
}

export default Monitoring;
